import React, { useState } from "react";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";
import { Form, InputGroup } from "react-bootstrap";

const FORM_DEFAULT = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

const ContactForm = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";
  const [isLoading, setIsLoading] = useState(false);

  const sheet_data = useGeneralSheetHook();
  // State to hold the form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  // State to handle form submission success/error
  const [formStatus, setFormStatus] = useState(null);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Here, you can add form validation and API submission logic
    await handleRegisterOnSheet();
  };

  const handleRegisterOnSheet = async () => {
    const scriptUrl = sheet_data["contact_form_micro"];

    setIsLoading(true);
    await fetch(scriptUrl, {
      method: "POST",
      body: JSON.stringify({ ...formData }),
      mode: "no-cors",
    })
      .then((res) => {
        if (res) {
          setFormData(FORM_DEFAULT);
          setFormStatus("Success! Your message has been sent.");
          // Reset form fields after submission
          setFormData({
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
          });
        }
      })
      .catch((err) => {
        setFormStatus("An error occurred. Please try again.");
      })
      .finally(function () {
        setIsLoading(false);
        setTimeout(() => {
          setFormStatus("");
        }, 2000);
      });
  };

  return (
    <>
      <section className="contact-page">
        <div
          className="contact-page-bg"
          style={{
            backgroundImage: `url(${publicUrl}assets/images/backgrounds/contact-page-bg.jpg)`,
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="contact-page__left">
                <div className="section-title text-left">
                  <span className="section-title__tagline">Contact Us</span>
                  <h2 className="section-title__title">
                    Get in touch with us <br /> We're here to assist you!
                  </h2>
                </div>
                <div className="contact-page__form">
                  <form
                    onSubmit={handleSubmit}
                    className="comment-one__form contact-form-validated"
                    // noValidate="novalidate"
                  >
                    <div className="row">
                      <div className="col-xl-6">
                        <div className="comment-form__input-box">
                          <Form.Group controlId="validationCustomUsername">
                            <InputGroup hasValidation>
                              <Form.Control
                                type="text"
                                placeholder="Your name"
                                name="name"
                                aria-describedby="inputGroupPrepend"
                                required
                                value={formData.name}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter name.
                              </Form.Control.Feedback>
                            </InputGroup>
                          </Form.Group>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="comment-form__input-box">
                          <Form.Group controlId="validationCustomUsername">
                            <InputGroup hasValidation>
                              <Form.Control
                                type="email"
                                placeholder="Email address"
                                name="email"
                                aria-describedby="inputGroupPrepend"
                                value={formData.email}
                                onChange={handleChange}
                              />
                            </InputGroup>
                          </Form.Group>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="comment-form__input-box">
                          <Form.Group controlId="validationCustomUsername">
                            <InputGroup hasValidation>
                              <Form.Control
                                type="text"
                                placeholder="Phone number"
                                name="phone"
                                aria-describedby="inputGroupPrepend"
                                required
                                value={formData.phone}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter first name.
                              </Form.Control.Feedback>
                            </InputGroup>
                          </Form.Group>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="comment-form__input-box">
                          <Form.Group controlId="validationCustomUsername">
                            <InputGroup hasValidation>
                              <Form.Control
                                type="text"
                                placeholder="Subject"
                                name="subject"
                                aria-describedby="inputGroupPrepend"
                                required
                                value={formData.subject}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter subject.
                              </Form.Control.Feedback>
                            </InputGroup>
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="comment-form__input-box text-message-box">
                          <textarea
                            name="message"
                            placeholder="Write a comment"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>
                        <div className="comment-form__btn-box">
                          <button
                            type="submit"
                            className={`thm-btn comment-form__btn ${
                              isLoading ? "disabled" : ""
                            }`}
                          >
                            {isLoading ? "Sending..." : "Send a message"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  {formStatus && <p className="form-status">{formStatus}</p>}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="contact-page__right">
                <div className="contact-page__img">
                  <img
                    src={
                      publicUrl +
                      "assets/images/resources/contact_us_woman_1.jpg"
                    }
                    alt=""
                  />
                  <div className="contact-page__img-shape">
                    <img
                      src={
                        publicUrl +
                        "assets/images/shapes/contact-page-img-shape.png"
                      }
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
